// extracted by mini-css-extract-plugin
export default {"popover":"styles__popover___vmFPT"};